import { Box, SkeletonText } from '@chakra-ui/react';
import React from 'react';

// eslint-disable-next-line max-len
const PLACEHOLDER_TEXT = 'Mathletics is brilliant and I have seen with my own eyes what a solid foundation in maths it has given both my children. They are confident and comfortable with the subject and I believe that Mathletics is the reason.';

export function CheckoutPricePanelSkeleton () {
    return (
        <Box data-testid={'checkout-price-panel-loading-fallback'}>
            <Box
                minHeight={'230px'}
                width={'100%'}
                boxShadow={'baseShadow'}
                borderRadius={'20px'}
                position={'relative'}
                padding={'12px'}
                borderColor={'secondary.500'}
                borderWidth={'1px'}
            >
                <SkeletonText
                    startColor={'neutral.100'}
                    endColor={'neutral.300'}
                    fadeDuration={1.2}
                    noOfLines={1}
                    skeletonHeight={'40px'}
                    my={'16px'}
                >
                    {PLACEHOLDER_TEXT}
                </SkeletonText>
                <SkeletonText
                    startColor={'neutral.100'}
                    endColor={'neutral.300'}
                    fadeDuration={1.2}
                    noOfLines={1}
                    skeletonHeight={'40px'}
                    mb={'24px'}
                >
                    {PLACEHOLDER_TEXT}
                </SkeletonText>

                <SkeletonText
                    startColor={'neutral.100'}
                    endColor={'neutral.300'}
                    fadeDuration={1.2}
                    noOfLines={1}
                    skeletonHeight={'58px'}
                >
                    {PLACEHOLDER_TEXT}
                </SkeletonText>
            </Box>
        </Box>
    );
}
